import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _createForOfIteratorHelper from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'logistics_hongde_driver_review_page',
  data: function data() {
    return {
      dayjs: dayjs,
      currentUser: localStorage.getItem('userId'),
      pageConfig: {
        editPageName: '司机审核',
        queryDriverFunName: 'logisticHongdeDriverAuditQuery',
        successFunName: 'logisticHongdeDriverAuditSuccess',
        failFunName: 'logisticHongdeDriverAuditFail',
        dicTreeFunName: 'mngDictionaryLowerTree',
        carTeamDetailFunName: 'logisticHongdeCarTeamDetail',
        authUserDetailFunName: 'mngUserDetail',
        driverDetailFunName: 'logisticHongdeDriverDetail'
      },
      searchForm: {
        page: 1,
        limit: 10,
        authState: null,
        name: null,
        carNumber: null,
        oldCarNumber: null,
        userState: null,
        sortField: 'create_time'
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      dicData: {
        upperCode: 'logistics_hd_car_type',
        configCarTypes: [],
        configCarTypeOptions: {},
        levelUpperCode: 'logistics_hd_driver_level',
        configLevels: [],
        configLevelOptions: {}
      },
      detailDialogShow: false,
      detailData: {},
      carTeam_info: {},
      authUser_info: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    Promise.all([new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.upperCode).then(function (res) {
        if (res.data) {
          _this.dicData.configCarTypes = res.data;
          for (var i = 0; i < res.data.length; i++) {
            _this.dicData.configCarTypeOptions[res.data[i].code] = res.data[i].name;
          }
        }
        resolve(res);
      });
    }), new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.levelUpperCode).then(function (res) {
        if (res.data) {
          _this.dicData.configLevels = res.data;
          for (var i = 0; i < res.data.length; i++) {
            _this.dicData.configLevelOptions[res.data[i].code] = res.data[i].name;
          }
        }
        resolve(res);
      });
    })]).then(function (result) {
      _this.query();
    });
  },
  methods: {
    detailClick: function detailClick(data) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var carImage, _iterator, _step, item, apply_data, _iterator2, _step2, _item, insuranceInsuranceImage, _iterator3, _step3, _item2;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              carImage = [];
              if (data.carImage && !(data.carImage instanceof Array)) {
                _iterator = _createForOfIteratorHelper(JSON.parse(data.carImage));
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    item = _step.value;
                    carImage.push(item.url);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }
              data.carImage = carImage;
              if (data.carTeam) {
                _this2.getCarTeam(data.carTeam);
              }
              if (data.authUserId) {
                _this2.getAuthUser(data.authUserId);
              }
              if (!(data.category != 'Apply')) {
                _context.next = 23;
                break;
              }
              apply_data = {};
              _context.next = 9;
              return _this2.$api[_this2.pageConfig.queryDriverFunName]({
                category: 'Apply',
                sortField: 'create_time',
                userId: data.userId
              }).then(function (res) {
                if (res.data.length > 0) {
                  apply_data = res.data[0];
                }
              });
            case 9:
              data.name = apply_data.name;
              data.contactPhone = apply_data.contactPhone;
              data.identityCard = apply_data.identityCard;
              data.identityCardImageFront = apply_data.identityCardImageFront;
              data.identityCardImageBack = apply_data.identityCardImageBack;
              data.carCategory = apply_data.carCategory;
              data.carImage = apply_data.carImage;
              data.wechatAccount = apply_data.wechatAccount;
              data.insuranceInsuranceImage = apply_data.insuranceInsuranceImage;
              data.insuranceLimitCost = apply_data.insuranceLimitCost;
              data.insuranceEndDate = apply_data.insuranceEndDate;
              if (data.carImage && !(data.carImage instanceof Array)) {
                _iterator2 = _createForOfIteratorHelper(JSON.parse(data.carImage));
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    _item = _step2.value;
                    carImage.push(_item.url);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
              }
              data.carImage = carImage;
              data.vehicleLicense = apply_data.vehicleLicense;
            case 23:
              insuranceInsuranceImage = [];
              if (data.insuranceInsuranceImage && !(data.insuranceInsuranceImage instanceof Array)) {
                _iterator3 = _createForOfIteratorHelper(JSON.parse(data.insuranceInsuranceImage));
                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    _item2 = _step3.value;
                    insuranceInsuranceImage.push(_item2.url);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
              }
              data.insuranceInsuranceImage = insuranceInsuranceImage;
              _this2.detailData = data;
              _this2.detailDialogShow = true;
            case 28:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getAuthUser: function getAuthUser(id) {
      var _this3 = this;
      this.$api[this.pageConfig.authUserDetailFunName](id).then(function (res) {
        _this3.authUser_info = res.data;
      });
    },
    getCarTeam: function getCarTeam(id) {
      var _this4 = this;
      this.$api[this.pageConfig.carTeamDetailFunName](id).then(function (res) {
        _this4.carTeam_info = res.data;
      });
    },
    fail: function fail(data) {
      var _this5 = this;
      this.$prompt('请填写驳回的原因', '驳回审核', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
        inputErrorMessage: '请填写驳回原因'
      }).then(function (_ref) {
        var value = _ref.value;
        console.log('then', value, _this5.pageConfig.failFunName);
        _this5.$api[_this5.pageConfig.failFunName]({
          id: data.id,
          authMsg: value
        }).then(function (res) {
          console.log('failFunName');
          _this5.$message.success('操作成功');
          _this5.query();
        });
      }).catch(function () {
        console.log('catch');
      });
    },
    success: function success(data) {
      var _this6 = this;
      this.$api[this.pageConfig.successFunName]({
        id: data.id,
        carTeamId: data.carTeam,
        authMsg: '通过'
      }).then(function (res) {
        _this6.$message.success('操作成功');
        _this6.query();
      });
    },
    query: function query() {
      var _this7 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryDriverFunName](this.searchForm).then(function (res) {
        _this7.tableData = res.data || [];
        _this7.totalCount = res.count;
        _this7.queryLoading = false;
      });
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};